import React from 'react';

import styles from './group-header.module.scss';

type GroupHeaderProps = {
  /** Optional leading icon, rendered before the title — e.g. a status icon on the task list. */
  icon?: React.ReactNode;
  title: string;
  count: number;
  /** Optional trailing action, e.g. a "create in this group" button. */
  action?: React.ReactNode;
};

/**
 * Shared strip for a grouped list's section header: icon, title, count, and an optional trailing
 * action. Used by both the task list and the crew list so the two stay visually identical —
 * keep this API small and push anything list-specific (icons, the create action) to the caller
 * rather than growing this component to know about tasks or crew.
 */
export const GroupHeader: React.FC<GroupHeaderProps> = ({ icon, title, count, action }) => (
  <div className={styles['header-strip']}>
    <div className={styles['left']}>
      {icon}
      <span className={styles['title']}>{title}</span>
      {/* A literal space, not just the title's own margin: it keeps the two spans' accessible
          text distinct (e.g. "Camera 3" rather than "Camera3") for anyone reading the group
          header's name via assistive tech or `getByRole`. */}{' '}
      <span className={styles['count']}>{count}</span>
    </div>

    {action && <div className={styles['action']}>{action}</div>}
  </div>
);
